__turbopack_context__.v({
  "chips": "NotificationDrawerFilters-module-scss-module__e2IEeq__chips",
  "filters": "NotificationDrawerFilters-module-scss-module__e2IEeq__filters",
  "markAllButton": "NotificationDrawerFilters-module-scss-module__e2IEeq__markAllButton",
});
